import { formatPostalCode } from './stringUtil';

/**
 * Mapping from the classified conditions
 * to a human readable description.
 * */
const conditions = {
  not_used: 'Ikke brukt',
  as_new: 'Som ny',
  some_markings: 'Noen markeringer',
  worn_but_readable: 'Brukt men lesbar',
};

const setPickupName = (classified, pickupAtSchool = false, hasCamelCase = false) => {
  if (pickupAtSchool) {
    return classified.school.shortName;
  }

  const salePoint = hasCamelCase ? classified.salePoint : classified.sale_point;
  const zipCode = salePoint?.zipCode || salePoint?.zip_code;
  const zipCodeLabel = zipCode?.id ? formatPostalCode(zipCode.id) : null;
  const salePointName = (
    hasCamelCase
      ? salePoint?.salePoint
      : salePoint?.sale_point
  ) || salePoint?.name || '';

  if (!zipCodeLabel && !salePointName) {
    return 'Avtales med selger';
  }

  if (!zipCodeLabel) {
    return salePointName;
  }

  if (!salePointName) {
    return zipCodeLabel;
  }

  return `${zipCodeLabel} ${salePointName}`;
};

const setPickupDetail = (classified, pickupAtSchool = false, hasCamelCase = false) => {
  if (pickupAtSchool) {
    return classified.school.department;
  }

  const salePoint = hasCamelCase ? classified.salePoint : classified.sale_point;
  const zipCode = salePoint?.zipCode || salePoint?.zip_code;

  return zipCode?.city || '';
};

// eslint-disable-next-line import/prefer-default-export
export function buildPickupLocation(classified) {
  const hasCamelCase = !!classified.pickupAt;

  const pickupAtSchool = hasCamelCase
    ? classified.pickupAt === 'school'
    : classified.pickup_at === 'school';

  return {
    name: setPickupName(classified, pickupAtSchool, hasCamelCase),
    detail: setPickupDetail(classified, pickupAtSchool, hasCamelCase),
  };
}

export const mapConditionToLabel = (condition) => conditions[condition] || null;
